import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullCalendarUIComponent } from './full-calendar-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FullCalendarModule } from '@fullcalendar/angular'; 
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
// import interactionPlugin from '@fullcalendar/interaction'; // a plugin

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
]);

@NgModule({
  declarations: [FullCalendarUIComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FullCalendarModule,
  ],
  exports: [FullCalendarUIComponent]
})
export class FullCalendarUIModule { }
